import React from 'react';
import { Typography } from 'material-ui';
import { assets } from '../../../assets';
import Lottie from 'react-lottie';
import { CircularProgress } from '@material-ui/core';

export class AvoidedCO2ConvertedWorldTour extends React.Component {
  render() {
    const {
      classes,
      t,
      avoidedCO2Grams,
      loading,
      co2_for_1km_travelled_in_g,
      world_tour_distance_in_km,
    } = this.props;

    if (loading) {
      return <CircularProgress size={10} className={classes.buttonProgress} />;
    }

    const myAnimatedPlane = {
      loop: true,
      autoplay: true,
      animationData: assets.lottie.aroundWorldPlane,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    let avoidedCo2g = avoidedCO2Grams;

    let nbOfPlaneKmConversion = avoidedCo2g / co2_for_1km_travelled_in_g;
    //118g        -> 1km
    //avoidedCo2g -> nbOfPlaneKmConversion

    let nbOfWorldTour = nbOfPlaneKmConversion / world_tour_distance_in_km;
    nbOfWorldTour = nbOfWorldTour.toFixed(1);
    //1tour              -> 40075km
    //nbOfWorldTour      -> nbOfPlaneKmConversion
    //Source : https://www.consoglobe.com/les-14-modes-de-transport-les-moins-polluants-cg

    return (
      <div>
        <div style={{ textAlign: 'center', align: 'center' }}>
          <Lottie options={myAnimatedPlane} width={70} height={70} />
        </div>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          <span style={{ fontSize: '1.2rem', color: '#F87733' }}>
            {nbOfWorldTour}
          </span>
        </Typography>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          {t('world tours by plane for one passenger')}
        </Typography>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/ConvertedAvoidedCO2/AvoidedCO2ConvertedWorldTour.js